import moment from 'moment-timezone';

//Available Vehicle Selected -> Calculation Start
export const getTheTotalAmountOnVehicleClassIsSelected = (selectedVehicleClassData: any) => {
    let totalPrice = 0.0;
    let totalHours = 0;
    let hourlyRate = 0.0;
    let totalDays = 0;
    let dailyRate = 0.0;
    let totalWeeks = 0;
    let weeklyRate = 0.0;
    let totalMonths = 0;
    let monthilyRate = 0.0;

    hourlyRate = selectedVehicleClassData?.hourlyRate || 0.0;
    dailyRate = selectedVehicleClassData?.dailyRate || 0.0;
    weeklyRate = selectedVehicleClassData?.weeklyRate || 0.0;
    monthilyRate = selectedVehicleClassData?.monthilyRate || 0.0;

    totalHours = selectedVehicleClassData?.hours || 0.0;

    if (selectedVehicleClassData?.days >= 30) {
        totalPrice = (
            parseInt((parseInt(selectedVehicleClassData?.days) / 30).toFixed(0)) * Number(selectedVehicleClassData?.monthilyRate)
            + parseInt(parseInt((parseInt(selectedVehicleClassData?.days) % 30) + "") / 7 + "") * Number(selectedVehicleClassData?.weeklyRate)
            + parseInt(((parseInt(selectedVehicleClassData?.days) % 30) % 7).toFixed(0)) * Number(selectedVehicleClassData?.dailyRate)
            + parseFloat(selectedVehicleClassData?.hours) * Number(selectedVehicleClassData?.hourlyRate)
        );

        totalMonths = parseInt(selectedVehicleClassData?.days / 30 + "");
        totalWeeks = parseInt(parseInt((selectedVehicleClassData?.days % 30) + "") / 7 + "");
        totalDays = parseInt((parseInt((selectedVehicleClassData?.days % 30) + "") % 7) + "");
    } else if (selectedVehicleClassData?.days >= 7) {
        totalPrice = (
            parseInt((parseInt(selectedVehicleClassData.days) / 7).toFixed(0)) * Number(selectedVehicleClassData.weeklyRate)
            + parseInt((parseInt(selectedVehicleClassData.days) % 7).toFixed(0)) * Number(selectedVehicleClassData.dailyRate)
            + parseFloat(selectedVehicleClassData.hours) * Number(selectedVehicleClassData.hourlyRate)
        );

        totalWeeks = parseInt(selectedVehicleClassData?.days / 7 + "");
        totalDays = parseInt((selectedVehicleClassData?.days % 7) + "");
    } else {
        totalPrice = (
            parseFloat(selectedVehicleClassData?.days) * Number(selectedVehicleClassData?.dailyRate) +
            parseFloat(selectedVehicleClassData?.hours) * Number(selectedVehicleClassData?.hourlyRate)
        );

        totalDays = parseInt((selectedVehicleClassData?.days % 7) + "");
    }

    return {
        totalPrice,
        totalHours,
        hourlyRate,
        totalDays,
        dailyRate,
        totalWeeks,
        weeklyRate,
        totalMonths,
        monthilyRate
    };
}

export const calculatedOnVehicleClassChangeAfterTheBooking = (totalPrice: number, totalAmountOfAdditionalCharge: number, appliedDiscountList: any[], totalPaid: number, totalRefunded: number) => {
    let totalAmountOfReservation = 0.0;
    let outstandingBalance = 0.0;
    let totalDiscountAmount = 0.0;    
    let updateAppliedList = [...appliedDiscountList];

    appliedDiscountList
        ?.filter((item: any) => item?.discountApplied)
        ?.forEach((item: any) => {
            if (item?.discountType === "Amount") {
                const amount = item?.discountAmount;
                totalDiscountAmount += amount;

                if (!item?.manualDiscount) {
                    updateAppliedList[0] = {
                        ...updateAppliedList[0],
                        discount: amount
                    }
                } else {
                    updateAppliedList[1] = {
                        ...updateAppliedList[1],
                        discount: amount
                    }
                }              
            } else {
                const amount = ((totalPrice * item?.discountAmount) / 100);
                totalDiscountAmount += amount;

                if (!item?.manualDiscount) {
                    updateAppliedList[0] = {
                        ...updateAppliedList[0],
                        discount: amount
                    }
                } else {
                    updateAppliedList[1] = {
                        ...updateAppliedList[1],
                        discount: amount
                    }
                }      
            }
        });

    totalAmountOfReservation = (totalPrice - totalDiscountAmount) + totalAmountOfAdditionalCharge;
    outstandingBalance = totalAmountOfReservation - (totalPaid - totalRefunded);

    return { totalAmountOfReservation, outstandingBalance, totalDiscountAmount, updateAppliedList };
}

export const getTheUpdateRatePrice = (
    totalPrice: number,
    outstandingBalance: number,
    oldTotalMonths: number,
    oldMonthlyRate: number,
    oldTotalWeeks: number,
    oldWeeklyRate: number,
    oldTotalDays: number,
    oldDailyRate: number,
    oldTotalHours: number,
    oldHourlyRate: number,
    newTotalMonths: number,
    newMonthlyRate: number,
    newTotalWeeks: number,
    newWeeklyRate: number,
    newTotalDays: number,
    newDailyRate: number,
    newTotalHours: number,
    newHourlyRate: number,
    minHoursForDay: number,
    appliedDiscountList: any[]
) => {
    let newTotalPrice = 0.0;
    let neOutstandingBalance = 0.0;
    let oldTotalDiscountAmount =  0.0;
    let newTotalDiscountAmount = 0.0; 
    let updateAppliedList = [...appliedDiscountList];

    const oldMonthlyPrice = oldTotalMonths * oldMonthlyRate;
    const oldWeeklyPrice = oldTotalWeeks * oldWeeklyRate;
    const oldDailyPrice = oldTotalDays * oldDailyRate;
    const oldHourlyPrice = oldTotalHours * oldHourlyRate;

    const newMonthlyPrice = newTotalMonths * newMonthlyRate;
    const newWeeklyPrice = newTotalWeeks * newWeeklyRate;

    let updateTotalDays = newTotalDays;
    let updateTotalHours = newTotalHours;

    if (newTotalHours > minHoursForDay) {
        updateTotalDays++;
        updateTotalHours = 0;
    }    

    const newDailyPrice = updateTotalDays * newDailyRate;
    const newHourlyPrice = updateTotalHours * newHourlyRate;

    const oldRackRates = oldMonthlyPrice + oldWeeklyPrice + oldDailyPrice + oldHourlyPrice;
    const newRackRates = newMonthlyPrice * newWeeklyPrice + newDailyPrice + newHourlyPrice;   

    appliedDiscountList
    ?.filter((item: any) => item?.discountApplied)
    ?.forEach((item: any) => {
        if (item?.discountType === "Amount") {
            oldTotalDiscountAmount += item?.discountAmount;
            newTotalDiscountAmount += item?.discountAmount;

            if (!item?.manualDiscount) {
                updateAppliedList[0] = {
                    ...updateAppliedList[0],
                    discount: item?.discountAmount
                }
            } else {
                updateAppliedList[1] = {
                    ...updateAppliedList[1],
                    discount: item?.discountAmount
                }
            }    
        } else {
            oldTotalDiscountAmount += ((oldRackRates * item?.discountAmount) / 100);
            newTotalDiscountAmount += ((newRackRates * item?.discountAmount) / 100);

            if (!item?.manualDiscount) {
                updateAppliedList[0] = {
                    ...updateAppliedList[0],
                    discount: ((newRackRates * item?.discountAmount) / 100)
                }
            } else {
                updateAppliedList[1] = {
                    ...updateAppliedList[1],
                    discount: ((newRackRates * item?.discountAmount) / 100)
                }
            }    
        }
    });


    newTotalPrice = totalPrice - oldRackRates + newRackRates + oldTotalDiscountAmount - newTotalDiscountAmount;
    neOutstandingBalance = outstandingBalance - oldRackRates + newRackRates + oldTotalDiscountAmount - newTotalDiscountAmount;

    return { oldRackRates, newRackRates, newTotalPrice, neOutstandingBalance, newTotalDiscountAmount, updateAppliedList };
}
//Available Vehicle Selected -> Calculation End


//Adjustment -> Calculation Start
export const calculateTheAdjustmentPriceByType = (extraValue: any, totalAmountOfSelectedVehicleClass: number, totalDays: number) => {
    let amountOrPercentage = 0.0;

    if (extraValue.chargeType === "Amount") {
         amountOrPercentage = parseFloat(extraValue?.basePrice?.toString() || "0");
    } else {
        amountOrPercentage = (parseFloat(extraValue?.basePrice?.toString() || "0") / totalAmountOfSelectedVehicleClass) * 100;
    }

    if (extraValue?.selectionType !== "Only One") {
        amountOrPercentage = amountOrPercentage / totalDays;
    }

    return amountOrPercentage;
}

export const calculateTheBasePriceOfAdjustment = (extraValue: any, totalAmountOfSelectedVehicleClass: number, totalDays: number) => {
    let basePriceOfAdjustment = 0.0;

    if (extraValue?.reservationAdditionalId > 0) {
        basePriceOfAdjustment = extraValue?.basePrice;
    } else {
        const amountOrPercentage = (extraValue.chargeType === "Amount"
            ? extraValue?.anountOrPercentage
            : (totalAmountOfSelectedVehicleClass *
                parseFloat(extraValue?.anountOrPercentage)) /
            100);

        basePriceOfAdjustment = (extraValue?.selectionType === "Only One"
            ? amountOrPercentage
            : totalDays *
            parseFloat(amountOrPercentage)
        );
    }

    return basePriceOfAdjustment;
}

export const getTheCheckExtraValue = (updatedExtraData: any[], totalAmountOfSelectedVehicleClass: number, totalDays: number) => {
    let additionalValue: any[] = [];
    const updatedCheckExtraData = updatedExtraData.map((item: any) => {
        const additionalCharges = item?.additionalCharges
            ?.filter((value: any) => value?.isChecked)
            ?.map((value: any) => {
                const basePrice = calculateTheBasePriceOfAdjustment(value, totalAmountOfSelectedVehicleClass, totalDays);

                return {
                    ...value,
                    basePrice: basePrice
                }
            });

        if (additionalCharges?.length > 0) {
            additionalValue = [...additionalValue, ...additionalCharges];
            return {
                ...item,
                additionalCharges
            };
        } else {
            return null;
        }
    })
        ?.filter((item: any) => item !== null);

    let addedAjustmentAmount = 0.0;
    addedAjustmentAmount = getTotalAmountOfAdditionalCharges(
        additionalValue?.map((item: any) => {
            return {
                quantity: item?.quantity,
                basePrice: item?.basePrice
            }
        })
    );

    return { addedAjustmentAmount, updatedCheckExtraData };
}

export const getTheCheckAdditionalCharges = (updatedExtraData: any[]) => {
    let additionalValue: any[] = [];
    const updatedCheckExtraData = updatedExtraData.map((item: any) => {
        const additionalCharges = item?.additionalCharges
            ?.filter((value: any) => value?.isChecked)           

        if (additionalCharges?.length > 0) {
            additionalValue = [...additionalValue, ...additionalCharges];
            return {
                ...item,
                additionalCharges
            };
        } else {
            return null;
        }
    })
        ?.filter((item: any) => item !== null);
  
    return updatedCheckExtraData;
}

const getTotalAmountOfAdditionalCharges = (adjustmentValue: any[]) => {
    let totalAdditionalChargeAmount = 0.0;
    adjustmentValue.forEach((item: any) => {
        const amount = parseFloat(item?.basePrice);
        if (!isNaN(amount)) {
            totalAdditionalChargeAmount += (item?.quantity * amount);
        }
    });

    return totalAdditionalChargeAmount;
}

export const getTheUpdateAdjustment = (
    totalPrice: number,
    outstandingBalance: number,
    oldQuantity: number,
    oldBasePirce: number,
    newQuantity: number,
    newBasePirce: number
) => {
    let newTotalPrice = 0.0;
    let neOutstandingBalance = 0.0;

    const oldPrice = oldQuantity * oldBasePirce;
    const newPrice = newQuantity * newBasePirce;

    newTotalPrice = totalPrice - oldPrice + newPrice;
    neOutstandingBalance = outstandingBalance - oldPrice + newPrice;

    return { newTotalPrice, neOutstandingBalance };
}
//Adjustment -> Calculation End


//Discount -> Calculation Start
export const calulatedDiscountValue = (discount: number, discountType: string, totalBasePriceBeforeDiscount: number) => {
    let discountAmount = 0.00;

    if (discountType === "Amount") {
        discountAmount = discount;
    } else {
        discountAmount = (totalBasePriceBeforeDiscount * discount) / 100;
    }

    return discountAmount;
}

export const setTheAddedDiscountList = (discountId: number, manualDiscount: string, isManualDiscountInAPercentage: boolean, discountOptionsOfBranch: any[], appliedDiscountList: any[]) => {
    const updatedAppliedDiscountList = [...appliedDiscountList];

    const discount = discountOptionsOfBranch?.find((item: any) => item?.id === discountId);
    if (discount) {     
        updatedAppliedDiscountList[0] = {
            ...updatedAppliedDiscountList[0],
            discountId: discountId,
            discountDefinition: discount?.name,
            discountType: discount?.discounttype || "Percentage",
            discountAmount: discount?.discountAmount || 0.00,
            discount: 0.00,
            discountApplied: true
        };
    } else {
        updatedAppliedDiscountList[0] = {
            ...updatedAppliedDiscountList[0],
            discountId: 0,
            discountDefinition: "",
            discountType: "Percentage",
            discountAmount: 0.00,
            discount: 0.00,
            discountApplied: false
        };
    }

    if (Number(manualDiscount) > 0) {
        updatedAppliedDiscountList[1] = {
            ...updatedAppliedDiscountList[1],
            discountDefinition: !isManualDiscountInAPercentage ? "Manual Discount" : `Manual Discount (${manualDiscount}%)`,
            discountType: !isManualDiscountInAPercentage ? "Amount" : "Percentage",
            discountAmount: Number(manualDiscount),
            discount: 0.00,
            discountApplied: true
        };
    } else {
        updatedAppliedDiscountList[1] = {
            ...updatedAppliedDiscountList[1],
            discountDefinition: "Manual Discount",
            discountType: "Amount",
            discountAmount: 0.00,
            discount: 0.00,
            discountApplied: false
        };
    }

    return updatedAppliedDiscountList;
}

export const setTheAddedDiscountValue = (discountId: number, manualDiscount: string, isManualDiscountInAPercentage: boolean, discountOptionsOfBranch: any[], totalAmountOfSelectedVehicleClass: number, appliedDiscountList: any[]) => {
    const updatedAppliedDiscountList = [...appliedDiscountList];

    const discount = discountOptionsOfBranch?.find((item: any) => item?.id === discountId);
    if (discount) {
        let discountAmount = 0.00;
        if (discount?.discounttype === "Amount") {
            discountAmount = parseFloat(
                discountOptionsOfBranch?.find(
                    (item: any) => item.id === discountId
                )?.discountAmount
            )
        } else {
            discountAmount = (totalAmountOfSelectedVehicleClass *
                parseFloat(
                    discountOptionsOfBranch?.find(
                        (item: any) => item.id === discountId
                    )?.discountAmount
                )) /
                100;
        }

        updatedAppliedDiscountList[0] = {
            ...updatedAppliedDiscountList[0],
            discountId: discountId,
            discountDefinition: discount?.name,
            discountType: discount?.discounttype || "Percentage",
            discountAmount: discount?.discountAmount || 0.00,
            discount: discountAmount
        };
    } else {
        updatedAppliedDiscountList[0] = {
            ...updatedAppliedDiscountList[0],
            discountId: 0,
            discountDefinition: "",
            discountType: "Percentage",
            discountAmount: 0.00,
            discount: 0.00,
        };
    }

    if (Number(manualDiscount) > 0) {
        let discountAmount = 0.00;

        if (isManualDiscountInAPercentage) {
            discountAmount = (totalAmountOfSelectedVehicleClass *
                parseFloat(manualDiscount)) /
                100;
        } else {
            discountAmount = parseFloat(manualDiscount);
        }

        updatedAppliedDiscountList[1] = {
            ...updatedAppliedDiscountList[1],
            discountDefinition: !isManualDiscountInAPercentage ? "Manual Discount" : `Manual Discount (${manualDiscount}%)`,
            discountType: !isManualDiscountInAPercentage ? "Amount" : "Percentage",
            discountAmount: Number(manualDiscount),
            discount: discountAmount
        };
    } else {
        updatedAppliedDiscountList[1] = {
            ...updatedAppliedDiscountList[1],
            discountDefinition: "Manual Discount",
            discountType: "Amount",
            discountAmount: 0.00,
            discount: 0.00
        };
    }

    return updatedAppliedDiscountList;
}

export const getTheTotalDiscountAmount = (addedDiscountList: any[]) => {
    let discountAmount = 0.0;
    addedDiscountList
        ?.filter((item: any) => item?.discountApplied)
        ?.forEach((item: any) => {
            discountAmount += parseFloat(item?.discount);
        });

    return discountAmount;
}

export const getTheTotalAmountAfterDiscount = (totalAmountOfSelectedVehicleClass: number, totalDiscountAmount: number) => {
    let totalAmount = 0.0;

    totalAmount = totalAmountOfSelectedVehicleClass - totalDiscountAmount;

    return totalAmount;
}
//Discount -> Calculation End


//FuelCharge -> Calculation Start
export const calculateFuelCharge = (fuelLevelOut: number, fuelLevelIn: number, fuelChargeAmount: number) => {
    let chargeAmount = 0.0;

    chargeAmount = (fuelLevelOut - fuelLevelIn) * fuelChargeAmount;
    return chargeAmount;
}
//FuelCharge -> Calculation End


//Tax -> Calculation Start
export const getTheTotalAmountOfTaxForAdditionalChange = (totalPrice: number, isDelete: boolean, newAmount: number, newValue: any, checkExtraValue: any[], taxList: any[], reservation: any, totalDays: number) => {
    let totalPriceAfterTax = 0.0;
    let totalPriceBeforeTaxForLocationFee = 0.0;
    let totalPriceBeforeTaxForSalesTax = 0.0;
    let totalPriceBeforeTax = 0.0;

    let mandatoryAdditionalChargesAmount = 0.0;
    let locationFeeAmount = 0.0;
    let taxAmount = 0.0;
    let governmentTaxAmount = 0.0;

    totalPriceAfterTax = isDelete ? totalPrice - newAmount : totalPrice + newAmount;
    totalPriceBeforeTaxForLocationFee = totalPrice;
    totalPriceBeforeTaxForSalesTax = totalPrice;
    totalPriceBeforeTax = isDelete ? totalPrice - newAmount : totalPrice + newAmount;
   
    const taxCalculateTheTax = () => {
        if (taxList?.length > 0) {
            totalPriceAfterTax -= (reservation?.mandatoryAdditionalChargesAmount > 0 ? reservation?.mandatoryAdditionalChargesAmount : 0);
            totalPriceBeforeTax -= (reservation?.mandatoryAdditionalChargesAmount > 0 ? reservation?.mandatoryAdditionalChargesAmount : 0);
            totalPriceBeforeTaxForLocationFee -= (reservation?.mandatoryAdditionalChargesAmount > 0 ? reservation?.mandatoryAdditionalChargesAmount : 0);
            totalPriceBeforeTaxForSalesTax -= (reservation?.mandatoryAdditionalChargesAmount > 0 ? reservation?.mandatoryAdditionalChargesAmount : 0);

            totalPriceAfterTax -= (reservation?.locationFeeAmount > 0 ? reservation?.locationFeeAmount : 0);
            totalPriceBeforeTaxForLocationFee -= (reservation?.locationFeeAmount > 0 ? reservation?.locationFeeAmount : 0);
            totalPriceBeforeTax -= (reservation?.locationFeeAmount > 0 ? reservation?.locationFeeAmount : 0);
            totalPriceBeforeTaxForSalesTax -= (reservation?.locationFeeAmount > 0 ? reservation?.locationFeeAmount : 0);

            totalPriceAfterTax -= (reservation?.taxAmount > 0 ? reservation?.taxAmount : 0);
            totalPriceBeforeTaxForSalesTax -= (reservation?.taxAmount > 0 ? reservation?.taxAmount : 0);
            totalPriceBeforeTax -= (reservation?.taxAmount > 0 ? reservation?.taxAmount : 0);
            totalPriceBeforeTaxForLocationFee -= (reservation?.taxAmount > 0 ? reservation?.taxAmount : 0);

            totalPriceAfterTax -= (reservation?.governmentTaxAmount > 0 ? reservation?.governmentTaxAmount : 0);
            totalPriceBeforeTax -= (reservation?.governmentTaxAmount > 0 ? reservation?.governmentTaxAmount : 0);
            totalPriceBeforeTaxForLocationFee -= (reservation?.governmentTaxAmount > 0 ? reservation?.governmentTaxAmount : 0);
            totalPriceBeforeTaxForSalesTax -= (reservation?.governmentTaxAmount > 0 ? reservation?.governmentTaxAmount : 0);

            mandatoryAdditionalChargesAmount = taxList?.find((item: any) => item?.taxName === "Additional Charge Fee")?.taxAmount ?? 0;
            totalPriceAfterTax += mandatoryAdditionalChargesAmount;

            const locationTaxAmount = taxList?.find((item: any) => item?.taxName === "Location Tax Fee")?.taxAmount ?? 0;
            locationFeeAmount = (locationTaxAmount * totalPriceBeforeTaxForLocationFee) / 100;
            totalPriceAfterTax += locationFeeAmount;

            const salestaxAmount = taxList?.find((item: any) => item?.taxName === "Tax Fee")?.taxAmount ?? 0;
            taxAmount = (salestaxAmount * totalPriceBeforeTaxForSalesTax) / 100;
            totalPriceAfterTax += taxAmount;

            const govtaxAmount = taxList?.find((item: any) => item?.taxName === "Government Tax Fee")?.taxAmount ?? 0;
            governmentTaxAmount = (govtaxAmount * totalPriceBeforeTax) / 100;
            totalPriceAfterTax += governmentTaxAmount;
        }
    }


    if (checkExtraValue?.length > 0) {
        checkExtraValue?.forEach((item: any, index: number) => {
            item?.additionalCharges?.forEach((value: any) => {
                if (parseInt(value?.reservationAdditionalId) !== parseInt(newValue?.reservationAdditionalId)) {
                    if (!value?.includeInLocationFee) {
                        totalPriceBeforeTaxForLocationFee -= value?.basePrice;
                    }

                    if (!value?.includeInTax) {
                        totalPriceBeforeTaxForSalesTax -= value?.basePrice;
                    }
                }
            });

            if (checkExtraValue?.length === index + 1) {
                if (isDelete) {
                    totalPriceBeforeTaxForLocationFee -= newAmount;
                    totalPriceBeforeTaxForSalesTax -= newAmount;
                } else {
                    if (newValue?.includeInLocationFee) {
                        totalPriceBeforeTaxForLocationFee += newAmount;
                    }

                    if (newValue?.includeInTax) {
                        totalPriceBeforeTaxForSalesTax += newAmount;
                    }
                }

                taxCalculateTheTax();
            }
        });
    } else {
        if (isDelete) {
            totalPriceBeforeTaxForLocationFee -= newAmount;
            totalPriceBeforeTaxForSalesTax -= newAmount;
        } else {
            if (newValue?.includeInLocationFee) {
                totalPriceBeforeTaxForLocationFee += newAmount;
            }

            if (newValue?.includeInTax) {
                totalPriceBeforeTaxForSalesTax += newAmount;
            }
        }
        taxCalculateTheTax();
    }

    return {
        totalPriceAfterTax,
        mandatoryAdditionalChargesAmount,
        locationFeeAmount,
        taxAmount,
        governmentTaxAmount
    }
}

export const getTheTotalAmountOfTax = (totalPrice: number, checkExtraValue: any[], taxList: any[], reservation: any, totalDays: number) => {
    let totalPriceAfterTax = 0.0;
    let totalPriceBeforeTaxForLocationFee = 0.0;
    let totalPriceBeforeTaxForSalesTax = 0.0;
    let totalPriceBeforeTax = 0.0;

    let mandatoryAdditionalChargesAmount = 0.0;
    let locationFeeAmount = 0.0;
    let taxAmount = 0.0;
    let governmentTaxAmount = 0.0;

    totalPriceAfterTax = totalPrice;
    totalPriceBeforeTaxForLocationFee = totalPrice;
    totalPriceBeforeTaxForSalesTax = totalPrice;
    totalPriceBeforeTax = totalPrice;

    const taxCalculateTheTax = () => {
        if (taxList?.length > 0) {
            totalPriceAfterTax -= (reservation?.mandatoryAdditionalChargesAmount > 0 ? reservation?.mandatoryAdditionalChargesAmount : 0);
            totalPriceBeforeTax -= (reservation?.mandatoryAdditionalChargesAmount > 0 ? reservation?.mandatoryAdditionalChargesAmount : 0);
            totalPriceBeforeTaxForLocationFee -= (reservation?.mandatoryAdditionalChargesAmount > 0 ? reservation?.mandatoryAdditionalChargesAmount : 0);
            totalPriceBeforeTaxForSalesTax -= (reservation?.mandatoryAdditionalChargesAmount > 0 ? reservation?.mandatoryAdditionalChargesAmount : 0);

            totalPriceAfterTax -= (reservation?.locationFeeAmount > 0 ? reservation?.locationFeeAmount : 0);
            totalPriceBeforeTaxForLocationFee -= (reservation?.locationFeeAmount > 0 ? reservation?.locationFeeAmount : 0);
            totalPriceBeforeTax -= (reservation?.locationFeeAmount > 0 ? reservation?.locationFeeAmount : 0);
            totalPriceBeforeTaxForSalesTax -= (reservation?.locationFeeAmount > 0 ? reservation?.locationFeeAmount : 0);

            totalPriceAfterTax -= (reservation?.taxAmount > 0 ? reservation?.taxAmount : 0);
            totalPriceBeforeTaxForSalesTax -= (reservation?.taxAmount > 0 ? reservation?.taxAmount : 0);
            totalPriceBeforeTax -= (reservation?.taxAmount > 0 ? reservation?.taxAmount : 0);
            totalPriceBeforeTaxForLocationFee -= (reservation?.taxAmount > 0 ? reservation?.taxAmount : 0);

            totalPriceAfterTax -= (reservation?.governmentTaxAmount > 0 ? reservation?.governmentTaxAmount : 0);
            totalPriceBeforeTax -= (reservation?.governmentTaxAmount > 0 ? reservation?.governmentTaxAmount : 0);
            totalPriceBeforeTaxForLocationFee -= (reservation?.governmentTaxAmount > 0 ? reservation?.governmentTaxAmount : 0);
            totalPriceBeforeTaxForSalesTax -= (reservation?.governmentTaxAmount > 0 ? reservation?.governmentTaxAmount : 0);


            mandatoryAdditionalChargesAmount = taxList?.find((item: any) => item?.taxName === "Additional Charge Fee")?.taxAmount ?? 0;
            totalPriceAfterTax += mandatoryAdditionalChargesAmount;

            const locationTaxAmount = taxList?.find((item: any) => item?.taxName === "Location Tax Fee")?.taxAmount ?? 0;
            locationFeeAmount = (locationTaxAmount * totalPriceBeforeTaxForLocationFee) / 100;
            totalPriceAfterTax += locationFeeAmount;

            const salestaxAmount = taxList?.find((item: any) => item?.taxName === "Tax Fee")?.taxAmount ?? 0;
            taxAmount = (salestaxAmount * totalPriceBeforeTaxForSalesTax) / 100;
            totalPriceAfterTax += taxAmount;

            const govtaxAmount = taxList?.find((item: any) => item?.taxName === "Government Tax Fee")?.taxAmount ?? 0;
            governmentTaxAmount = (govtaxAmount * totalPriceBeforeTax) / 100;
            totalPriceAfterTax += governmentTaxAmount;
        }
    }

    if (checkExtraValue?.length > 0) {
        checkExtraValue?.forEach((item: any, index: number) => {
            item?.additionalCharges?.forEach((value: any) => {
                if (!value?.includeInLocationFee) {
                    totalPriceBeforeTaxForLocationFee -= value?.basePrice;
                }

                if (!value?.includeInTax) {
                    totalPriceBeforeTaxForSalesTax -= value?.basePrice;
                }
            })

            if (checkExtraValue?.length === index + 1) {
                taxCalculateTheTax();
            }
        });
    } else {
        taxCalculateTheTax();
    }

    return {
        totalPriceAfterTax,
        mandatoryAdditionalChargesAmount,
        locationFeeAmount,
        taxAmount,
        governmentTaxAmount
    }
}

//Tax -> Calculation Start
export const getTheTotalAmountOfTaxForAdditionalChangeForChange = (totalPrice: number, newTotalPriceBeforeTaxForLocationFee: number, newTotalPriceBeforeTaxForSalesTax: number, taxList: any[], reservation: any, totalDays: number) => {
    let totalPriceAfterTax = 0.0;
    let totalPriceBeforeTaxForLocationFee = 0.0;
    let totalPriceBeforeTaxForSalesTax = 0.0;
    let totalPriceBeforeTax = 0.0;

    let mandatoryAdditionalChargesAmount = 0.0;
    let locationFeeAmount = 0.0;
    let taxAmount = 0.0;
    let governmentTaxAmount = 0.0;

    totalPriceAfterTax = totalPrice;
    totalPriceBeforeTaxForLocationFee = newTotalPriceBeforeTaxForLocationFee;
    totalPriceBeforeTaxForSalesTax = newTotalPriceBeforeTaxForSalesTax;
    totalPriceBeforeTax = totalPrice;

    const taxCalculateTheTax = () => {
        if (taxList?.length > 0) {
            totalPriceAfterTax -= (reservation?.mandatoryAdditionalChargesAmount > 0 ? reservation?.mandatoryAdditionalChargesAmount : 0);
            totalPriceBeforeTax -= (reservation?.mandatoryAdditionalChargesAmount > 0 ? reservation?.mandatoryAdditionalChargesAmount : 0);
            totalPriceBeforeTaxForLocationFee -= (reservation?.mandatoryAdditionalChargesAmount > 0 ? reservation?.mandatoryAdditionalChargesAmount : 0);
            totalPriceBeforeTaxForSalesTax -= (reservation?.mandatoryAdditionalChargesAmount > 0 ? reservation?.mandatoryAdditionalChargesAmount : 0);

            totalPriceAfterTax -= (reservation?.locationFeeAmount > 0 ? reservation?.locationFeeAmount : 0);
            totalPriceBeforeTaxForLocationFee -= (reservation?.locationFeeAmount > 0 ? reservation?.locationFeeAmount : 0);
            totalPriceBeforeTax -= (reservation?.locationFeeAmount > 0 ? reservation?.locationFeeAmount : 0);
            totalPriceBeforeTaxForSalesTax -= (reservation?.locationFeeAmount > 0 ? reservation?.locationFeeAmount : 0);

            totalPriceAfterTax -= (reservation?.taxAmount > 0 ? reservation?.taxAmount : 0);
            totalPriceBeforeTaxForSalesTax -= (reservation?.taxAmount > 0 ? reservation?.taxAmount : 0);
            totalPriceBeforeTax -= (reservation?.taxAmount > 0 ? reservation?.taxAmount : 0);
            totalPriceBeforeTaxForLocationFee -= (reservation?.taxAmount > 0 ? reservation?.taxAmount : 0);

            totalPriceAfterTax -= (reservation?.governmentTaxAmount > 0 ? reservation?.governmentTaxAmount : 0);
            totalPriceBeforeTax -= (reservation?.governmentTaxAmount > 0 ? reservation?.governmentTaxAmount : 0);
            totalPriceBeforeTaxForLocationFee -= (reservation?.governmentTaxAmount > 0 ? reservation?.governmentTaxAmount : 0);
            totalPriceBeforeTaxForSalesTax -= (reservation?.governmentTaxAmount > 0 ? reservation?.governmentTaxAmount : 0);


            mandatoryAdditionalChargesAmount = taxList?.find((item: any) => item?.taxName === "Additional Charge Fee")?.taxAmount ?? 0;
            totalPriceAfterTax += mandatoryAdditionalChargesAmount;

            const locationTaxAmount = taxList?.find((item: any) => item?.taxName === "Location Tax Fee")?.taxAmount ?? 0;
            locationFeeAmount = (locationTaxAmount * totalPriceBeforeTaxForLocationFee) / 100;
            totalPriceAfterTax += locationFeeAmount;

            const salestaxAmount = taxList?.find((item: any) => item?.taxName === "Tax Fee")?.taxAmount ?? 0;
            taxAmount = (salestaxAmount * totalPriceBeforeTaxForSalesTax) / 100;
            totalPriceAfterTax += taxAmount;

            const govtaxAmount = taxList?.find((item: any) => item?.taxName === "Government Tax Fee")?.taxAmount ?? 0;
            governmentTaxAmount = (govtaxAmount * totalPriceBeforeTax) / 100;
            totalPriceAfterTax += governmentTaxAmount;
        }
    }

    taxCalculateTheTax();

    return {
        totalPriceAfterTax,
        mandatoryAdditionalChargesAmount,
        locationFeeAmount,
        taxAmount,
        governmentTaxAmount
    }
}

export const getTheTotalAmountOfTaxForAdditionalChangeOnVehicleChange = (totalPrice: number, newTotalPriceBeforeTaxForLocationFee: number, newTotalPriceBeforeTaxForSalesTax: number, taxList: any[], totalDays: number) => {
    let totalPriceAfterTax = 0.0;
    let totalPriceBeforeTaxForLocationFee = 0.0;
    let totalPriceBeforeTaxForSalesTax = 0.0;
    let totalPriceBeforeTax = 0.0;

    let mandatoryAdditionalChargesAmount = 0.0;
    let locationFeeAmount = 0.0;
    let taxAmount = 0.0;
    let governmentTaxAmount = 0.0;

    totalPriceAfterTax = totalPrice;
    totalPriceBeforeTaxForLocationFee = newTotalPriceBeforeTaxForLocationFee;
    totalPriceBeforeTaxForSalesTax = newTotalPriceBeforeTaxForSalesTax;
    totalPriceBeforeTax = totalPrice;

    const taxCalculateTheTax = () => {
        if (taxList?.length > 0) {
            mandatoryAdditionalChargesAmount = taxList?.find((item: any) => item?.taxName === "Additional Charge Fee")?.taxAmount ?? 0;
            totalPriceAfterTax += mandatoryAdditionalChargesAmount;

            const locationTaxAmount = taxList?.find((item: any) => item?.taxName === "Location Tax Fee")?.taxAmount ?? 0;
            locationFeeAmount = (locationTaxAmount * totalPriceBeforeTaxForLocationFee) / 100;
            totalPriceAfterTax += locationFeeAmount;

            const salestaxAmount = taxList?.find((item: any) => item?.taxName === "Tax Fee")?.taxAmount ?? 0;
            taxAmount = (salestaxAmount * totalPriceBeforeTaxForSalesTax) / 100;
            totalPriceAfterTax += taxAmount;

            const govtaxAmount = taxList?.find((item: any) => item?.taxName === "Government Tax Fee")?.taxAmount ?? 0;
            governmentTaxAmount = (govtaxAmount * totalPriceBeforeTax) / 100;
            totalPriceAfterTax += governmentTaxAmount;
        }
    }

    taxCalculateTheTax();

    return {
        totalPriceAfterTax,
        mandatoryAdditionalChargesAmount,
        locationFeeAmount,
        taxAmount,
        governmentTaxAmount
    }
}
//Tax -> Calculation End


//ExtraMileCharge -> Calculation Start
export const calculateForExtraMiles = (totalDays: number, totalWeeks: number, totalMonths: number, selectedVehicleClassData: any) => {
    let includedMiles = 0;

    includedMiles = (totalDays * selectedVehicleClassData?.distanceLimitperDay)
        + (totalWeeks * selectedVehicleClassData?.distanceLimitperWeek)
        + (totalMonths * selectedVehicleClassData?.distanceLimitperMonth);

    return includedMiles;
}

//To Get the branch Timezone
export const branchTimezone = (formattedCreatedAt: string) => {
    const UpdateTimezone =
        formattedCreatedAt !== "" &&
            formattedCreatedAt !== null &&
            formattedCreatedAt !== "string" &&
            formattedCreatedAt !== "null"
            ? new Date().toLocaleString("en-US", {
                timeZone: formattedCreatedAt?.split(" ")[2],
            })
            : new Date().toLocaleString("en-US", {
                timeZone: moment.tz.guess(),
            });

    return UpdateTimezone;
}